import { __assign } from "tslib";
import * as React from 'react';
import style from './CircularProgressBar.st.css';
import { Arc } from './Arc';
import { dataHooks } from './constants';
var FULL_PROGRESS = 100;
var NO_PROGRESS = 0;
var VIEWBOX_SIZE = 54;
var resolveIndicationElement = function (props) {
    var wrapped = function (dataHook, children) { return (React.createElement("div", { "data-hook": dataHook, className: style.statusIndicator }, children)); };
    if (props.error && props.errorIcon) {
        return wrapped(dataHooks.errorIcon, props.errorIcon);
    }
    if (props.value === FULL_PROGRESS && props.successIcon) {
        return wrapped(dataHooks.successIcon, props.successIcon);
    }
};
var normalizeValue = function (value) {
    return typeof value === 'number'
        ? value
        : parseInt(value, 10)
            ? parseInt(value, 10)
            : NO_PROGRESS;
};
var normalizeSize = function (size) {
    var intSize = typeof size === 'number' ? size : parseInt(size, 10);
    return intSize && intSize > 0 ? intSize : VIEWBOX_SIZE;
};
var renderArcs = function (props) {
    var value = props.value, size = props.size;
    var normalizedSize = normalizeSize(size);
    var normalizedValue = normalizeValue(value);
    return (React.createElement("div", { className: style.arcsContainer, style: { width: normalizedSize + "px", height: normalizedSize + "px" } },
        resolveIndicationElement(props),
        React.createElement(Arc, { "data-hook": dataHooks.progressArcBackground, value: FULL_PROGRESS, className: style.backArc, strokeWidth: 4, size: normalizedSize }),
        React.createElement(Arc, { "data-hook": dataHooks.progressArcForeground, value: normalizedValue, className: style.foreArc, strokeWidth: 4, size: normalizedSize })));
};
var normalizeProps = function (props) {
    var value = normalizeValue(props.value);
    if (value >= FULL_PROGRESS) {
        return __assign(__assign({}, props), { value: FULL_PROGRESS });
    }
    if (value < NO_PROGRESS) {
        return __assign(__assign({}, props), { value: NO_PROGRESS });
    }
    return __assign(__assign({}, props), { value: value });
};
export var CircularProgressBar = function (props) {
    var error = props.error, showProgressIndication = props.showProgressIndication;
    var _props = normalizeProps(props);
    var success = _props.value === FULL_PROGRESS;
    var value = error && _props.errorLabel
        ? _props.errorLabel
        : Math.floor(_props.value) + "%";
    return (React.createElement("div", __assign({}, style('root', { error: error, success: success }, _props), { "data-error": error }),
        renderArcs(_props),
        showProgressIndication && (React.createElement("div", { "data-hook": dataHooks.progressIndicator, className: style.progressIndicator }, value))));
};
CircularProgressBar.displayName = 'CircularProgressBar';
CircularProgressBar.defaultProps = {
    value: NO_PROGRESS,
    size: VIEWBOX_SIZE,
};
//# sourceMappingURL=CircularProgressBar.js.map